import { styles, variants, FormLayoutTheme } from '../FormLayoutStyles.css';
import { baseTheme } from './FormLayoutBaseTheme.css';
import { multiVariantStyles } from './FormLayoutVariants.css';

const FormLayoutRedwoodTheme: FormLayoutTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { FormLayoutRedwoodTheme };
